export default __webpack_public_path__ + "static/media/avesha.9adc28cb.png";